module.exports = __webpack_public_path__ + "static/media/logo_icon_color.a6e83f27.png";